{
	"content": {
		"title": "Seleziona i materiali che richiedono dichiarazioni",
		"materialListLabel": "Materiale",
		"materialQuantityLabel": "Quantità di materiale ({{unit}})",
		"availableQuantityLabel": "Quantità disponibile ({{unit}})",
		"carbonSavingsLabel": "Riduzioni di carbonio ({{unit}} CO₂ eq.)"
	},
	"summary": {
		"title": "Riepilogo",
		"declarationTypeTitle": "Tipo di dichiarazione",
		"customerProjectTitle": "Progetto del cliente",
		"internalProjectOrProductTitle": "Progetto / prodotto interno",
		"projectReferenceTitle": "Riferimento del progetto",
		"materialHeaderTitle": "Materiale",
		"quantityHeaderTitle": "Quantità ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Riduzioni di carbonio allocabili ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Riduzione di carbonio non allocabile ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "La quantità è obbligatoria",
		"quantityPositive": "Inserisci una quantità positiva.",
		"quantityLargerThanAvailable": "Riduci la quantità al totale disponibile",
		"savingsRequired": "Le riduzioni di carbonio sono obbligatorie",
		"fetchNotTransferedMaterialsError": "Impossibile recuperare i materiali non trasferiti"
	},
	"submitTitle": "Aggiungi al progetto",
	"backTitle": "Indietro"
}
